import React from 'react';
import { BrowserRouter, Routes, Route, Link } from 'react-router-dom';
import styled from '@emotion/styled';
import { NeuraProvider } from './contexts/NeuraContext.tsx';
import { SimpleChatPage } from './SimpleChatPage.tsx';
import { HomePage } from './HomePage.tsx';  // We'll create this
import { TestChat } from './components/TestChat.tsx';
import { Debug } from './components/Debug.tsx';



const NavBar = styled.nav`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  background: rgba(0, 0, 0, 0.8);
  padding: 10px 20px;
  display: flex;
  gap: 20px;
  z-index: 2000;
`;

const NavLink = styled(Link)`
  color: #00ff88;
  text-decoration: none;
  padding: 8px 16px;
  border: 1px solid #00ff88;
  border-radius: 4px;
  font-family: monospace;
  
  &:hover {
    background: rgba(0, 255, 136, 0.2);
  }
`;

const PageContainer = styled.div`
  padding-top: 0px; // Account for navbar
`;

const App = () => {
  return (
    <BrowserRouter>
      <NeuraProvider>
        <NavBar>
          <NavLink to="/">Home</NavLink>
          <NavLink to="/chat">Simple Chat</NavLink>
        </NavBar>
        
        <PageContainer>
          <Routes>
            <Route path="/" element={<HomePage />} />
            <Route path="/chat" element={<SimpleChatPage />} />
          </Routes>
        </PageContainer>
      </NeuraProvider>
      {/* <TestChat /> */}
      {/* <Debug /> */}
    </BrowserRouter>
  );
};

export default App; 